const APPLE_REVIEW_EMAIL = "developer@sajilni.com";

/** Env-gated Apple review OTP; unset / not 4 digits = existing random+DB path. */
export function appleReviewStaticOtp(identifier: string): number | null {
  const raw = process.env.APPLE_REVIEW_OTP?.trim();
  if (!raw || !/^\d{4}$/.test(raw)) return null;
  if (identifier.trim().toLowerCase() !== APPLE_REVIEW_EMAIL) return null;
  return Number(raw);
}

export function isAppleReviewOtp(identifier: string, code: number): boolean {
  const reviewOtp = appleReviewStaticOtp(identifier);
  return reviewOtp !== null && reviewOtp === code;
}
